// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Configure_container__XNoGG {
  animation: Configure_init__brTbr 0.5s;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_title__XwYHk .Configure_createButton__IVCBc {
  transition: 0.3s;
  width: 10%;
  height: 2.5rem;
  margin-inline: 10px;
  font-weight: 400;
  font-size: 1rem;
  text-decoration: none;
  margin-bottom: 5px;
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_title__XwYHk .Configure_createButton__IVCBc .Configure_btn__h9KIL {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.Configure_btn__h9KIL:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.05;
  filter: brightness(1.2);
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_table__S-nhx {
  width: 100%;
  margin-bottom: 50px;
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_paper__eNQs8 {
  width: 100%;
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_tableContainer__N3Y1A {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.268);
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_tableContainer__N3Y1A .Configure_tableCellHeader__Bq1S4 {
  font-size: 0.9rem;
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_tableCell__tpz8A {
  font-family: Roboto, sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  border-bottom: 1px solid rgba(0, 0, 0, 0.455);
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_title__XwYHk {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  margin-bottom: 30px;
}

.Configure_container__XNoGG .Configure_configureContainer__lsqSL .Configure_title__XwYHk h1 {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.Configure_noConfigs__qEKVI {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.Configure_msg_container__HXVba {
  height: 25px;
  cursor: pointer;
}

@keyframes Configure_init__brTbr {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Configure/index.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAoB;EACpB,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.container .configureContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 90%;\n}\n\n.container .configureContainer .title .createButton {\n  transition: 0.3s;\n  width: 10%;\n  height: 2.5rem;\n  margin-inline: 10px;\n  font-weight: 400;\n  font-size: 1rem;\n  text-decoration: none;\n  margin-bottom: 5px;\n}\n\n.container .configureContainer .title .createButton .btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n}\n\n.btn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.05;\n  filter: brightness(1.2);\n}\n\n.container .configureContainer .table {\n  width: 100%;\n  margin-bottom: 50px;\n}\n\n.container .configureContainer .table .paper {\n  width: 100%;\n}\n\n.container .configureContainer .table .tableContainer {\n  width: 100%;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .configureContainer .table .tableContainer .tableCellHeader {\n  font-size: 0.9rem;\n}\n\n.container .configureContainer .table .tableCell {\n  font-family: Roboto, sans-serif;\n  font-size: 0.9rem;\n  font-weight: 400;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.455);\n}\n\n.container .configureContainer .title {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 30px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.container .configureContainer .title h1 {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.noConfigs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.msg_container {\n  height: 25px;\n  cursor: pointer;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Configure_container__XNoGG`,
	"init": `Configure_init__brTbr`,
	"configureContainer": `Configure_configureContainer__lsqSL`,
	"title": `Configure_title__XwYHk`,
	"createButton": `Configure_createButton__IVCBc`,
	"btn": `Configure_btn__h9KIL`,
	"table": `Configure_table__S-nhx`,
	"paper": `Configure_paper__eNQs8`,
	"tableContainer": `Configure_tableContainer__N3Y1A`,
	"tableCellHeader": `Configure_tableCellHeader__Bq1S4`,
	"tableCell": `Configure_tableCell__tpz8A`,
	"noConfigs": `Configure_noConfigs__qEKVI`,
	"msg_container": `Configure_msg_container__HXVba`
};
export default ___CSS_LOADER_EXPORT___;
